

export const getConfirmationSmartbox = async (data = {}) => {

    const generateId = (await import(/* webpackPrefetch: true */ "../../classes/universal_methods/generateId.js")).generateId;

    const displaySmartboxWithPreloader = (await import(/* webpackPrefetch: true */ "../display/displaySmartboxWithPreloader.js")).displaySmartboxWithPreloader;

    const setTxtV2 = (await import(/* webpackPrefetch: true */ "../../classes/universal_methods/setTxtV2.js")).setTxtV2;


    let { title, heading, subHeading, informationTexts, buttonText, smartboxName, functionDetails, showClickInstruction, showHeading } = data;

    
    title = setTxtV2({ attributes: {}, txt: title || "txt515", type: "html" });
    heading = setTxtV2({ attributes: {}, txt: heading || "txt515", type: "html" });
    subHeading = setTxtV2({ attributes: {}, txt: subHeading || "txt751", type: "html" });
    buttonText = setTxtV2({ attributes: {}, txt: buttonText || "txt514", type: "html" });

    

    if (informationTexts && Array.isArray(informationTexts) ) {

        let information = "";

        for (let i = 0; i < informationTexts.length; i++) {
            const text = informationTexts[i];

            information += `<p class="smetio-margin-bottom-10"> ${setTxtV2({ attributes: {}, txt: text, type: "html" })}  </p>`;
        };

        informationTexts = information;

    };


    const { preloader, smetioSmartbox } = await displaySmartboxWithPreloader({ title });

    preloader.hide();

    const newPreloader = preloader.render();

    const id = generateId();

    const clickInstruction = showClickInstruction !== false ? `<p class="smetio-p-text smetio-margin-top-40 smetio-margin-bottom-30">${subHeading}</p>` : "";
    const headingInstruction = showHeading !== false ? `<h4 class="smetio-h4-heading smetio-margin-bottom-30">${heading}</h4>` : "";

    const content = `
    
        <div class=" smetio-flex-column-horizontal-center ">

            ${newPreloader}

            ${headingInstruction}

            ${informationTexts || ""}

            ${clickInstruction}

            <button class="smetio-smart-box-button smetio-confirm-action-btn smetio-confirm-action-btn-${id} smetio-dominant-button">
                ${buttonText}
            </button>

        </div>

    `;

    smetioSmartbox.updateContent(content);

    const { functionPath, functionParameters } = functionDetails;

    functionParameters.smetioSmartbox = smetioSmartbox;
    functionParameters.preloader = preloader;
    functionParameters.id = id;

    if(smartboxName) window[smartboxName] = smetioSmartbox;

    $("body").on("mousedown", `.smetio-confirm-action-btn-${id}`, async (event) => {

        if(!functionParameters) return false;

        const functionName = functionPath.split("/").pop();
        const func = await import(/* webpackPrefetch: true */ `../${functionPath}.js`);
    
        if (func[functionName]) func[functionName](functionParameters);

    });

};
